import React from 'react'
import { useStylesFor } from '@codeleap/web'
import { StyleSheets, StyleRegistry, Settings } from '@/config'
import { StyledProp, StyledComponent } from '@codeleap/styles'
import { ImageComposition } from '@/config/stylesheets/Image'
import { StaticImageData } from 'next/image'
import NextImage, { ImageProps as NextImageProps } from 'next/image'
import { Medias } from '@/config/packages'

export type ImageProps =
  Omit<Partial<NextImageProps>, 'style' | 'src'> &
  {
    source: StaticImageData | string
    alt: string
    objectFit?: React.CSSProperties['objectFit']
    style?: StyledProp<ImageComposition>
  }

export const Image: StyledComponent<typeof StyleSheets.ImageStyles, ImageProps> = (props) => {
  const {
    source,
    objectFit = 'contain',
    style,
    alt = `${Settings.AppName} Image`,
    className,
    ...rest
  } = props

  const styles = useStylesFor(Image.styleRegistryName, style)

  const stringSource = typeof source === 'string' ? source : null
  const { src: mediaSrc, onError: mediaOnError, isCdnMedia } = Medias.useResolvedUrl(stringSource)

  const resolvedSrc = stringSource === null ? source : mediaSrc

  return (
    <div css={styles.wrapper} className={className}>
      {resolvedSrc ? (
        <NextImage
          {...rest}
          alt={alt}
          fill={true}
          src={resolvedSrc as NextImageProps['src']}
          onError={isCdnMedia ? mediaOnError : rest.onError}
          style={{ position: 'absolute', objectFit }}
        />
      ) : null}
    </div>
  )
}

Image.styleRegistryName = 'Image'
Image.elements = ['wrapper']

StyleRegistry.registerComponent(Image)
